import { Buffer } from 'buffer';
import crypto from 'crypto';

import type { GetPreSignedUrlResult } from 'bundles/fileuploader-uppy/components/PreSignedUrlProvider';
import type { UppyS3UploadParams } from 'bundles/fileuploader-uppy/types/UppyFileUploader';

const DEFAULT_CRYPTO_ALGO = 'md5';
const DEFAULT_CRYPTO_ENCODING = 'base64';

export const calcCheckSum = ({ file }: { file: File | Blob }): Promise<string> =>
  new Promise((resolve, reject) => {
    const hash = crypto.createHash(DEFAULT_CRYPTO_ALGO);
    const reader = new FileReader();
    const error = new Error('Unable to calculate file checksum');

    reader.onerror = (event) => {
      reject(error);
    };

    reader.onload = (event) => {
      if (reader.result instanceof ArrayBuffer) {
        const buffer = Buffer.from(new Uint8Array(reader.result));
        resolve(
          // note: this line seems to cause issues in snowpack but ok in webpack in main branch
          hash
            .update(
              // @ts-expect-error TSUPGRADE5.5-5.7 FIXME: error TS2345: Argument of type 'Buffer' is not assignable to parameter of type 'BinaryLike'.
              buffer
            )
            .digest(DEFAULT_CRYPTO_ENCODING)
        );
      } else {
        reject(error);
      }
    };

    reader.readAsArrayBuffer(file);
  });

export const buildS3UploadParams = ({ url, additionalHeaders }: GetPreSignedUrlResult): UppyS3UploadParams => {
  if (!url) {
    throw new Error('Unable to build S3 upload params: Missing pre-signed url data');
  }
  const headers = additionalHeaders.reduce<Record<string, string>>((acc, curr) => {
    acc[curr.name] = curr.value;
    return acc;
  }, {});

  return {
    method: 'PUT',
    url,
    headers,
    fields: {},
  };
};

export default {
  calcCheckSum,
  buildS3UploadParams,
};
